<template>
    <nav class="breadcrumb-nav">
        <ul class="breadcrumb-list">
            <li v-for="(item, idx) in breadcrumbList" :key="idx">
                <span>{{ item.label }}</span>
                <span v-if="idx < breadcrumbList.length - 1" class="sep">&gt;&gt;</span>
            </li>
        </ul>
    </nav>
</template>

<script>
const routeMap = {
    '/': '首页',
    '/about': '首页 >> 关于我们',
    '/project': '首页 >> 工程案例',
    '/project/:id': '首页 >> 工程案例',
    '/contact': '首页 >> 联系我们',
    '/news': '首页 >> 新闻动态',
    '/qualification': '首页 >> 企业资质'
};
export default {
    name: 'Breadcrumb',
    computed: {
        breadcrumbList() {
            // 详情页特殊处理
            if (this.$route.name === 'ProjectDetail' && this.$route.params.id) {
                return [
                    { label: '首页' },
                    { label: '工程案例' },
                    { label: '项目详情' }
                ];
            }
            if (this.$route.name === 'NewsDetail' && this.$route.params.id) {
                return [
                    { label: '首页' },
                    { label: '新闻动态' },
                    { label: '新闻详情' }
                ];
            }
            const matched = this.$route.matched.filter(r => r.path !== '');
            let list = matched.map(r => ({ label: routeMap[r.path] || r.name || r.path }));
            return list.length ? list : [{ label: '首页' }];
        }
    }
};
</script>

<style scoped>
.breadcrumb-nav {
    background: none;
    padding: 18px 0 0 0;
    font-size: 0.98rem;
    margin-bottom: 0;
}

.breadcrumb-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    list-style: none;
    padding: 0 0 0 8px;
    margin: 0;
}

.breadcrumb-list li {
    color: #888;
    font-weight: 500;
}

.breadcrumb-list a {
    color: #2563eb;
    text-decoration: none;
    transition: color 0.2s;
}

.breadcrumb-list a:hover {
    color: #1a2a47;
    text-decoration: underline;
}

.sep {
    margin: 0 8px;
    color: #bbb;
}
</style>